import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import 'iconify-icon';

const BRAND_ICONS: Record<string, string> = {
  sharepoint: 'thesvg-color:microsoft-sharepoint',
  github: 'simple-icons:github',
  outlook: 'thesvg-color:microsoft-outlook',
  slack: 'thesvg-color:slack',
  teams: 'thesvg-color:microsoft-teams',
  googlechat: 'thesvg-color:google-chat',
  jira: 'thesvg-color:jira',
  postgresql: 'thesvg-color:postgresql',
  mysql: 'simple-icons:mysql',
  sqlserver: 'thesvg-color:microsoft-sql-server',
  azureboards: 'thesvg-color:microsoft-azure',
  googledrive: 'thesvg-color:google-drive',
  ftp: 'mdi:server-network',
  upload: 'mdi:upload',
  generic: 'mdi:connection'
};

@Component({
  selector: 'app-brand-icon',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  host: {
    '[class.fluid]': 'fluid'
  },
  template: `
    <iconify-icon
      [attr.icon]="iconName"
      [attr.width]="fluid ? '100%' : size"
      [attr.height]="fluid ? '100%' : size"
      [attr.aria-label]="name"
    ></iconify-icon>
  `,
  styles: [`
    :host {
      display: inline-flex;
      flex-shrink: 0;
      line-height: 0;
    }

    :host.fluid {
      width: 100%;
      height: 100%;
    }

    iconify-icon {
      display: block;
    }

    :host.fluid iconify-icon {
      width: 100%;
      height: 100%;
    }
  `]
})
export class BrandIcon {
  @Input({ required: true }) name!: keyof typeof BRAND_ICONS | string;
  @Input() size = 32;
  @Input() fluid = false;

  get iconName(): string {
    return BRAND_ICONS[this.name] ?? this.name;
  }
}
